module.exports = __webpack_public_path__ + "static/media/add_document.9b74d1a0.svg";